module.exports = __webpack_public_path__ + "img/404.097371c6.svg";